module.exports = __webpack_public_path__ + "img/typing.ce02a62b.jpg";